import { Box, FormHelperText, Grid, TextareaAutosize } from '@mui/material';
import { UseControllerProps } from 'react-hook-form';
import useSanitizedTextController from '../customHooks/useSanitizedTextController';
import AppInformationText from './AppInformationText';

var normalStyles = { width: '100%' };

var errorStyles = {
  ...normalStyles,
  border: '2px solid red'
};

interface Props extends UseControllerProps {
  label: string;
  placeholder?: string;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  type?: string;
  information_text_with_label?: string;
  information_text_with_textarea?: string;
  variant?: "outlined"
  maxStringCount?: number;
}

export default function AppTextareaInput(props: Props) {
  const { defaultValue, maxStringCount, ...textareaProps } = props;
  const { fieldState, field } = useSanitizedTextController({ ...props, defaultValue: defaultValue ?? '' });

  return (
    <>
      <Grid container rowSpacing={1}>

        <Grid size={{ xs: 11, md: 11, sm: 11 }}>
          {props.label}
          {props.information_text_with_label &&
            <div style={{ marginTop: '-37px', marginLeft: props.label.length * 10 }}>
              <AppInformationText information_text={props.information_text_with_label} placement={'right'} />
            </div>}
        </Grid>

        <Grid size={{ xs: 1, md: 1, sm: 1 }}></Grid>

        <Grid size={{ xs: 12 }}></Grid>

        <Grid size={{ xs: 11 }}>
          <TextareaAutosize
            minRows={10}
            style={fieldState.error ? errorStyles : normalStyles}
            className="rcsiTextField"
            {...textareaProps}
            {...field}
            value={field.value ?? ''}
          />
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <FormHelperText sx={{ color: 'primary.main', flex: 1 }}>{fieldState.error?.message}</FormHelperText>
            {maxStringCount != null && (
              <FormHelperText sx={{ textAlign: 'right', flexShrink: 0 }}>
                {String(field.value ?? '').length}/{maxStringCount}
              </FormHelperText>
            )}
          </Box>
        </Grid>

        <Grid size={{ xs: 1 }}>
          {props.information_text_with_textarea && <AppInformationText information_text={props.information_text_with_textarea} />}
        </Grid>
      </Grid>
    </>
  );
}
